<div class="debug-window" *ngIf="broadcastService.debug">
  Channel: {{ broadcastService.channelName$ | async }}<br />
  Session ID: {{ authService.id$ | async }}<br />
  Instances: {{ broadcastService.instances$ | async }}
</div>
